/**
 * @generated SignedSource<<3aa8ad57b1cc391ffa619ccc64abf63a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_IssueNavigatorUI_project$data = {
  readonly projectType: JiraProjectType | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_Header_project" | "main_issueNavigator_IssueResults_project" | "topBar_issueNavigator_project">;
  readonly " $fragmentType": "main_issueNavigator_IssueNavigatorUI_project";
};
export type main_issueNavigator_IssueNavigatorUI_project$key = {
  readonly " $data"?: main_issueNavigator_IssueNavigatorUI_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigatorUI_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_IssueNavigatorUI_project",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_IssueResults_project"
    },
    {
      "kind": "FragmentSpread",
      "name": "topBar_issueNavigator_project"
    },
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_Header_project"
    },
    {
      "kind": "ScalarField",
      "name": "projectType"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "3819962f1d2f3d78660cdc939122719a";

export default node;
